import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const TermsOfService = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 bg-stone-50">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h1 className="text-3xl font-bold text-green-900 mb-8">Terms of Service</h1>
          <div className="bg-white rounded-xl border border-stone-200 p-8 space-y-6 text-stone-700 leading-relaxed">
            <p>By using Nark Online, you agree to the following terms:</p>

            <section>
              <h2 className="text-lg font-semibold text-stone-900 mb-2">1. Platform Role</h2>
              <p>Nark Online operates as an online shopping platform that sources and sells products directly to customers.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-stone-900 mb-2">2. Pricing</h2>
              <p>All prices include a markup applied by Nark Online.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-stone-900 mb-2">3. Payments</h2>
              <p>All payments are processed securely via Paystack.</p>
              <p>Nark Online assumes full responsibility for payment processing.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-stone-900 mb-2">4. Delivery</h2>
              <p>Deliveries are carried out by third-party partners, including the Eersterust Tuk Tuk Association.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-stone-900 mb-2">5. Liability</h2>
              <ul className="list-disc pl-6 space-y-1">
                <li>Nark Online is responsible for payments and order coordination</li>
                <li>Delivery partners are responsible for delivery execution</li>
                <li>Nark Online is not liable for indirect losses or delays beyond reasonable control</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-stone-900 mb-2">6. User Responsibilities</h2>
              <p>Customers agree to:</p>
              <ul className="list-disc pl-6 space-y-1 mt-1">
                <li>Provide accurate delivery information</li>
                <li>Be available to receive orders</li>
                <li>Use the platform lawfully</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-stone-900 mb-2">7. Account Suspension</h2>
              <p>We reserve the right to suspend users for abuse, fraud, or misuse.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-stone-900 mb-2">8. Changes to Terms</h2>
              <p>Nark Online may update these terms at any time.</p>
              <p>Continued use of the platform constitutes acceptance of updated terms.</p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsOfService;
